export const SET_AUDIO_DEVICES_LIST = 'SET_AUDIO_DEVICES_LIST';
export const SET_AUDIO_CURRENT_DEVICE = 'SET_AUDIO_CURRENT_DEVICE';
export const SET_VOLUME = 'SET_VOLUME';
export const SET_VIDEO_DEVICES_LIST = 'SET_VIDEO_DEVICES_LIST';
export const SET_VIDEO_CURRENT_DEVICE = 'SET_VIDEO_CURRENT_DEVICE';
export const SET_TEXTTOSPEECH_VOICES_LIST = 'SET_TEXTTOSPEECH_VOICES_LIST';
export const SET_TEXTTOSPEECH_CURRENT_VOICE = 'SET_TEXTTOSPEECH_CURRENT_VOICE';
export const SET_RESOLUTION = 'SET_RESOLUTION';
export const CHANGE_IS_CAMERA_LOADING = 'CHANGE_IS_CAMERA_LOADING';
export const SET_STREAM_CHANGE_COUNT = 'SET_STREAM_CHANGE_COUNT';
